import { GameOverScreen } from '@/screens/new-design/GameOverScreen'

export default function () {
  return <GameOverScreen />
}
